
const sale            = require('../applications/staff/desktop/entity/sale/sale')
const retail          = require('../applications/staff/desktop/entity/retail/retail')
const purchase        = require('../applications/staff/desktop/entity/purchase/purchase')
const chat            = require('../components/chat/chat')


//tv
const staffTv         = require ('../applications/staff/tv/staff-tv')

export const obj = {
        sale:           { start: function(detail){ sale.start(detail)           }},
        retail:         { start: function(detail){ retail.start(detail)         }},
        purchase:       { start: function(detail){ purchase.start(detail)       }},
        chat:           { start: function(detail){ chat.start(detail)           }},
}
